import GraniteError from 'granite-admin/utils/granite-error';
import userAPI from 'granite-admin/accounts/gateways/user-api';
import accountsUserAPI from 'accounts/gateways/user_api';
import { TWO_FA_LAYER_EVENTS } from './events';
//add docs
async function submitToken(eventEmitter, token, email, phone) {
  try {
    await userAPI.submitToken(token, email, phone);
    eventEmitter.emit(TWO_FA_LAYER_EVENTS.SUBMIT_TOKEN_SUCCESS);
  } catch (error) {
    const err = new GraniteError(error);
    eventEmitter.emit(TWO_FA_LAYER_EVENTS.SUBMIT_TOKEN_FAILURE, err?.errors);
  }
}
async function resendOtp(eventEmitter, values, setErrors) {
  const payload = { email: values.email, phone: values.phone };
  try {
    await accountsUserAPI.resendOtp(payload);
    eventEmitter.emit(TWO_FA_LAYER_EVENTS.RESEND_OTP_SUCCESS);
  } catch (error) {
    const err = new GraniteError(error);
    eventEmitter.emit(TWO_FA_LAYER_EVENTS.RESEND_OTP_FAILURE, { err, setErrors });
  }
}

export { submitToken, resendOtp };
